module.exports = __webpack_public_path__ + "media/8.34048031.mp3";